// extracted by mini-css-extract-plugin
export default {"hd_image":"style_hd_image__YLUvT","img_video":"style_img_video__c1K9L","img_video_thumb":"style_img_video_thumb__ty93Q"};